import { useEffect, useState } from "react";
import { api, type ReviewItem } from "../lib/api";
import { pct } from "../lib/format";

/**
 * Fronta ručního párování.
 *
 * Automaticky se páruje jen jistá shoda. Fuzzy návrhy jsou tu jako pomůcka
 * pro člověka, nikdy jako rozhodnutí: chybné spárování je tichá kontaminace
 * dat, kterou v číslech nepoznáš.
 */
export function Review() {
  const [items, setItems] = useState<ReviewItem[] | null>(null);
  const [error, setError] = useState("");

  const load = () => api.reviewQueue().then((r) => setItems(r.items)).catch((e: Error) => setError(e.message));
  useEffect(() => { void load(); }, []);

  const resolve = async (id: string, body: { teamId?: string; ignore?: boolean }) => {
    try {
      await api.resolveReview(id, body);
      await load();
    } catch (e) {
      setError((e as Error).message);
    }
  };

  if (error) return <p className="notice warn">{error}</p>;
  if (!items) return <p className="empty">Načítám.</p>;

  return (
    <>
      <h1>{items.length === 0 ? "Fronta je prázdná" : `${items.length} názvů k potvrzení`}</h1>
      <p className="lede">
        Tyhle názvy se nepodařilo bezpečně spárovat. Dokud je nepotvrdíš, kurzy k jejich zápasům
        se neukládají. Surové odpovědi zůstávají uložené, takže se po potvrzení dopočítají zpětně.
      </p>

      {items.length === 0 ? (
        <p className="empty">Všechno se páruje samo. Sem se dostane jen to, co je nejednoznačné.</p>
      ) : (
        items.map((item) => (
          <section key={item.id} style={{ borderBottom: "1px solid var(--rule)", padding: "1rem 0" }}>
            <div className="signal-match">{item.raw_value.rawName}</div>
            <p className="signal-meta" style={{ marginTop: "0.25rem" }}>
              {item.provider_code}, {item.raw_value.reason || "neznámý název"}
            </p>
            {item.candidates.length === 0 ? (
              <p className="notice">
                Žádný podobný tým v databázi. Nejspíš jde o nový tým, který zatím nikdo nezaložil.
              </p>
            ) : (
              <div className="field-row" style={{ marginTop: "0.75rem" }}>
                {item.candidates.map((candidate) => (
                  <button key={candidate.teamId} className="action quiet"
                          onClick={() => void resolve(item.id, { teamId: candidate.teamId })}>
                    {candidate.canonicalName} ({pct(candidate.similarity, 0)})
                  </button>
                ))}
              </div>
            )}
            <p style={{ marginTop: "0.75rem" }}>
              <button className="action quiet" onClick={() => void resolve(item.id, { ignore: true })}>
                Ignorovat
              </button>
            </p>
          </section>
        ))
      )}
    </>
  );
}
